import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Auth0Provider} from "@auth0/auth0-react";
import {redirect_uri} from "./config";


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Auth0Provider domain={"auth.platform.symbl.ai"} clientId={"VFacwdPS37LZA7hjhDtp8WUlSNXCcdAb"}
                       authorizationParams={{
                           redirect_uri: redirect_uri ? redirect_uri : window.location.origin,
                           audience: "https://api-nebula.symbl.ai"
                       }}>
            <App/>
        </Auth0Provider>
        {/*<AppDemo/>*/}
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
